export default class SystemInfo {
    static FixedId = 'systemInfo';
    _id = SystemInfo.FixedId;
    backendId;
    backendVersion;
    backendSoftwareName;
    backendCommitShortSha;
    backendCommitRefSlug;
    backendSentryRelease;
    gatewayInfo;
    versionRequiringClientDataReset;
}
//# sourceMappingURL=SystemInfo.js.map